import { follow } from "@/content/copy";
import { Eyebrow, Owl, Reveal, TikTokButton } from "./primitives";

export const Follow = () => (
  <section data-testid="follow-journey-section" className="ph-section relative overflow-hidden">
    <div className="ph-container relative">
      <div className="ph-follow-frame">
        <div className="ph-follow-owl" aria-hidden="true"><Owl alt="" className="w-full h-auto" /></div>
        <Reveal className="relative z-10 max-w-3xl">
          <Eyebrow>{follow.eyebrow}</Eyebrow>
          <h2 data-testid="follow-journey-title" className="ph-display mt-6">{follow.heading}</h2>
          <p className="ph-lead mt-8 max-w-xl">{follow.body}</p>
          <TikTokButton testId="cta-btn-tiktok" className="ph-btn-lg mt-10">{follow.button}</TikTokButton>
        </Reveal>
      </div>
    </div>
  </section>
);
